import React from "react";
import { Link } from "react-router-dom/dist";
import bookDeepak from "../../assets/images/webp/other/book-deepak.webp";
import { SOCIAL_LINKS_LIST } from "../../utils/other-component";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";

const BookEvent = () => {
  return (
    <>
      <div className="max-w-[1440px] mx-auto pb-60 xl:pb-80">
        <div className="flex items-center justify-between max-xl:gap-6 max-lg:flex-wrap-reverse">
          <div className="w-full max-w-[575px] mx-auto max-lg:max-w-full max-lg:px-4">
            <BlueTag>Booking</BlueTag>
            <Heading className="pb-10 max-md:pb-6 ">
              Book Deepak Sharma for Your Next Event
            </Heading>

            <div className="flex gap-3 flex-col ">
              {SOCIAL_LINKS_LIST.map((obj, i) => (
                <Link
                  key={i}
                  to={obj.link}
                  className="flex items-center gap-3 text-[#010101] text-base font-normal leading-[160%]"
                >
                  <span>{obj.icon}</span>
                  {obj.title}
                </Link>
              ))}
            </div>
            <h2 className="font-normal text-[22px] italic leading-[130%] text-[#010101] pt-6">
              “My roots are in the village, but my vision is global.” –
              <span className="font-bold">Deepak Sharma</span>
            </h2>
          </div>
          <div className="w-full max-w-[657px] max-lg:mx-auto">
            <img
              src={bookDeepak}
              alt="deepak"
              width={657}
              height={634}
              className="w-full object-contain"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BookEvent;
